// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wS73","input":"styles_input__HIi0r"};